import React, { useEffect, useState } from "react";

const StickyUpcomingTripsBtn = ({ upcomingTripsRef, faqRef }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!upcomingTripsRef.current || !faqRef.current) return;

      const calendarTop = upcomingTripsRef.current.getBoundingClientRect().top;
      const faqTop = faqRef.current.getBoundingClientRect().top;

      if (calendarTop <= 0 && faqTop > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [upcomingTripsRef, faqRef]);

  if (!visible) return null;

  return (
    <button className="sticky-upcoming-trips-btn">
      <a href="#upcomingTrips" className="custom--sticky-ut-btn">Upcoming Trips</a>
    </button>
  );
};

export default StickyUpcomingTripsBtn; 